import React, { Component } from 'react';
import './index.css';
import Loading from '../shared/Loading';
import { m } from '../../utils';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import Button from '../../artzu-ui/src/Button';
import Modal from '../../artzu-ui/src/Modal';
import BarGraph from '../../artzu-ui/src/BarGraph';
import { Link } from 'react-router-dom';
import { StripeProvider } from 'react-stripe-elements';
import NegativeBalance from '../NewPayments/NegativeBalance';
// import { faPlus } from '@fortawesome/pro-solid-svg-icons';

const query = gql`
  query earningGraph {
    currentUser {
      id
      email
      firstName
      lastName
    }
    pastSevenPaychecks {
      period
      payout
      balance
      outstandingBalance
      realTimeBalance
    }
    highestPaycheck {
      period
      payout
      outstandingBalance
      realTimeBalance
    }
    latestStatement {
      period
      payout
      balance
      outstandingBalance
      realTimeBalance
    }
  }
`;

class EarningWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      index: null,
      showPaymentModal: false,
    };
  }

  handleIndexChange = index => {
    this.setState({ index });
  };

  render() {
    const { index } = this.state;
    const { status } = this.props;
    const api_key = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
    return (
      <Query query={query} fetch-policy="network-only">
        {({ loading, error, data, refetch }) => {
          if (loading)
            return (
              <div className="load-div">
                <Loading size="3x" />
              </div>
            );
          const paychecks = data.pastSevenPaychecks;
          const barGraphTemp = {};
          for (let i = 5; i >= -1; i--) {
            barGraphTemp[
              m()
                .subtract(i, 'week')
                .clone()
                .startOf('isoWeek')
                .format('MMM D')
            ] = { value: 0, index: Math.abs(i - 5) };
          }
          paychecks.forEach(paycheck => {
            if (
              barGraphTemp[m(paycheck.period.replace(/.*\.\./i, '').replace(/\s.*/i, ''), 'YYYY-MM-DD').format('MMM D')]
            ) {
              barGraphTemp[
                m(paycheck.period.replace(/.*\.\./i, '').replace(/\s.*/i, ''), 'YYYY-MM-DD').format('MMM D')
              ].value =
                paycheck.payout || paycheck.realTimeBalance;
            }
          });
          const bars = Object.keys(barGraphTemp)
            .map(key => ({ label: key, value: barGraphTemp[key].value, index: barGraphTemp[key].index }))
            .sort((a, b) => a.index - b.index);
          const user = data.currentUser;
          const latestStatement = data.latestStatement;
          return (
            <div className="earning-widget">
              {status === 'negative_balance' ? (
                <Modal open={this.state.showPaymentModal}>
                  <StripeProvider apiKey={api_key}>
                    <NegativeBalance
                      email={user.email}
                      firstName={user.firstName}
                      lastName={user.lastName}
                      owing={false}
                      amount={Math.abs(latestStatement.realTimeBalance.toFixed(2))}
                      onClick={() => this.setState({ showPaymentModal: false })}
                    />
                  </StripeProvider>
                </Modal>
              ) : null}
              <div className="dash-top">
                <p>Earnings</p>
                <Link to="/myearnings">View Details</Link>
              </div>
              <div className="earning-numbers">
                {bars ? (
                  <div className="current-week">
                    <p>
                      {m(
                        `${bars[typeof index === 'number' ? index : bars.length - 1].label} ${m().year()} 04:00:00`
                      ).isBefore(m())
                        ? 'Previous Balance'
                        : 'Current Balance'}
                    </p>
                    <h3
                      style={{
                        color: m(
                          `${bars[typeof index === 'number' ? index : bars.length - 1].label} ${m().year()} 04:00:00`
                        ).isBefore(m())
                          ? '#414141'
                          : 'ff0000',
                      }}>
                      ${bars[typeof index === 'number' ? index : bars.length - 1].value.toFixed(2)}
                    </h3>
                  </div>
                ) : (
                  <div />
                )}
                {status === 'negative_balance' ? (
                  <Button
                    primary
                    className="widget-pay"
                    label="Pay Balance"
                    color="#ff0000"
                    padding="0"
                    onClick={() => this.setState({ showPaymentModal: true })}
                  />
                ) : null}
                {data.highestPaycheck && status !== 'negative_balance' ? (
                  <div className="best-week">
                    <p>Best Week</p>
                    <h3>${data.highestPaycheck.payout}</h3>
                  </div>
                ) : (
                  <div />
                )}
              </div>
              <BarGraph data={bars} handleIndexChange={this.handleIndexChange} selected={index} />
            </div>
          );
        }}
      </Query>
    );
  }
}

export default EarningWidget;



// WEBPACK FOOTER //
// ./src/components/NewDash/EarningWidget.js